import React from "react";
import { Formik, Form, Field } from "formik";
import l from "components/util/l";

const ExportForm = ({ 
  activeCollection, 
  isExporting = false,
  onClickExport = () => { } 
}) => {

  return <div className="card">

    <div class="card-header">
      <h3 class="mb-0">
        {l("Descargar excel%CA066")}
      </h3>
    </div>
    <div class="card-body py-4">
      <Formik
        initialValues={{ limit: "100" }}
        onSubmit={(values) => {
          // An empty limit exports every row.
          onClickExport(values.limit || null);
        }}
      >
        {({ values, setFieldValue }) =>
          <Form>

            <div class="form-group mb-4">
              <span class="d-flex justify-content-between dropdown-header pt-0 pb-2 px-0">
                <span style={{ color: "#777" }}>
                  {l("Registros%CA067")}
                </span>
              </span>
              <div class="input-group">
                <Field
                  as="select"
                  name="limit"
                  id="limit"
                  class="form-control"
                >
                  <option value="100">{l("Últimos {count}%CA069", {count: 100})}</option>
                  <option value="500">{l("Últimos {count}%CA069", {count: 500})}</option>
                  <option value="1000">{l("Últimos {count}%CA069", {count: 1000})}</option>
                  <option value="">{l("Todos%GA030")}</option>
                </Field>
              </div>
            </div>

            <div className="d-flex justify-content-between">
              <button
                type="submit"
                class="btn btn-block btn-primary mt-3"
                disabled={isExporting}
              >
                {isExporting ? (
                  <>
                    <i className="fas fa-spinner fa-pulse mr-2"></i>
                    {l("Descargando archivo...%CA200")}
                  </>
                ) : l("Descargar archivo%CA072")}
              </button>

            </div>

          </Form>}
      </Formik>
    </div>
  </div>
}

export default ExportForm;